module.exports = __webpack_public_path__ + "static/media/HCMM970.383ad46b.jpg";